import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-74d94536")
const _hoisted_1 = {
  key: 0,
  class: "text-xs text-gray-700 dark:text-gray-500"
}
const _hoisted_2 = { class: "font-bold dark:text-gray-300" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "font-medium  dark:text-gray-500" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "font-medium  dark:text-gray-500" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "font-medium capitalize  dark:text-gray-500" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "font-medium  dark:text-gray-500" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "font-medium  dark:text-gray-500" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = { class: "font-medium capitalize dark:text-gray-500" }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" You can continue to create your pool anyway, but you’ll have to pay pool creation gas costs and liquidity will be fractured which is likely to result in your new pool being less profitable. ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Continue anyway")
_popScopeId()

import { computed } from 'vue';

import usePoolCreation from '@/composables/pools/usePoolCreation';
import useWeb3 from '@/services/web3/useWeb3';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';

import TokenPills from '@/components/tables/PoolsTable/TokenPills/TokenPills.vue';
import { useI18n } from 'vue-i18n';
import { orderBy, take } from 'lodash';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const { userNetworkConfig, isWalletReady } = useWeb3();
const {
  similarPools,
  isLoadingSimilarPools,
  existingPool,
  setStep,
  proceed,
  resetPoolCreationState,
  goBack
} = usePoolCreation();
const { fNum2 } = useNumbers();
const { t } = useI18n();

/** COMPUTED */
const title = computed(() => {
  if (existingPool.value) return t('createAPool.poolAlreadyExists');
  return t('createAPool.similarPoolsExist');
});

// limit the similar pools on the UI to the first 4 ones
// with highest tvl
const relevantSimilarPools = computed(() => {
  return take(
    orderBy(similarPools.value, pool => Number(pool.totalLiquidity), 'desc'),
    4
  );
});

/**
 * FUNCTIONS
 */
function cancel() {
  resetPoolCreationState();
  setStep(0);
}

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    shadow: "xl",
    noBorder: "",
    class: _normalizeClass({ 'border-red-400': _unref(existingPool) })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BalStack, { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_BalStack, {
            vertical: "",
            spacing: "xs"
          }, {
            default: _withCtx(() => [
              (_unref(isWalletReady))
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(userNetworkConfig)?.name), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_BalStack, {
                align: "center",
                horizontal: "",
                spacing: "xs"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(goBack) && _unref(goBack)(...args))),
                    class: "text-red-500 hover:text-red-700 flex"
                  }, [
                    _createVNode(_component_BalIcon, {
                      class: "flex",
                      name: "chevron-left"
                    })
                  ]),
                  _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(title)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(existingPool))
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('createAPool.existingPoolInfo')), 1))
            : _createCommentVNode("", true),
          (_unref(isLoadingSimilarPools))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_unref(existingPool))
              ? (_openBlock(), _createBlock(_component_BalCard, {
                  key: 2,
                  shadow: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BalStack, { vertical: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_BalStack, {
                          spacing: "sm",
                          horizontal: "",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_BalAssetSet, {
                                width: 35,
                                addresses: _unref(existingPool).tokensList
                              }, null, 8, ["addresses"])
                            ]),
                            _createVNode(TokenPills, {
                              tokens: _unref(existingPool).tokens
                            }, null, 8, ["tokens"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_BalStack, {
                          horizontal: "",
                          spacing: "lg"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BalStack, {
                              vertical: "",
                              spacing: "none"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('poolValue')), 1),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(fNum2)(_unref(existingPool).totalLiquidity, _unref(FNumFormats).fiat)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_BalStack, {
                              vertical: "",
                              spacing: "none"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('volume24hShort')), 1),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(fNum2)(_unref(existingPool).dynamic.volume, _unref(FNumFormats).fiat)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_BalStack, {
                              vertical: "",
                              spacing: "none"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('fees')), 1),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(fNum2)(_unref(existingPool).swapFee, _unref(FNumFormats).percent)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_BalStack, {
                  key: 3,
                  vertical: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relevantSimilarPools), (pool) => {
                      return (_openBlock(), _createBlock(_component_BalCard, {
                        shadow: "none",
                        key: pool.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BalStack, { vertical: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BalStack, {
                                spacing: "sm",
                                horizontal: "",
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_BalAssetSet, {
                                      width: 35,
                                      addresses: pool.tokensList
                                    }, null, 8, ["addresses"])
                                  ]),
                                  _createVNode(TokenPills, {
                                    tokens: pool.tokens
                                  }, null, 8, ["tokens"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_BalStack, {
                                horizontal: "",
                                spacing: "xl"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_BalStack, {
                                    vertical: "",
                                    spacing: "none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('poolValue')), 1),
                                      _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(fNum2)(pool.totalLiquidity, _unref(FNumFormats).fiat)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_BalStack, {
                                    vertical: "",
                                    spacing: "none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('volume24hShort')), 1),
                                      _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(fNum2)(pool.dynamic.volume, _unref(FNumFormats).fiat)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_BalStack, {
                                    vertical: "",
                                    spacing: "none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('fees')), 1),
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(fNum2)(pool.swapFee, _unref(FNumFormats).percent)), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })),
          (!_unref(existingPool))
            ? (_openBlock(), _createBlock(_component_BalAlert, {
                key: 4,
                block: "",
                type: "warning",
                title: "Are you sure you want to continue?"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_BalStack, {
            horizontal: "",
            expandChildren: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BalBtn, {
                onClick: cancel,
                block: "",
                outline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              (!_unref(existingPool))
                ? (_openBlock(), _createBlock(_component_BalBtn, {
                    key: 0,
                    onClick: _unref(proceed),
                    block: "",
                    class: "next-button"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})